import LoadPage from '@/services/Pagination'

const Pagination = (url, params) => {
  return new Promise((resolve, reject) => {
    LoadPage(url, params, [], resolve, reject)
  })
}

export default Pagination
